import { useRequest } from 'features/request/useRequest';
import { useResetStoreData } from 'features/request/useResetStoreData';

import { useCallback, useEffect, useMemo } from 'react';
import { useDispatch } from 'react-redux';

import { uerUpdateWorkOrderOtherPriceRationaleGql } from '../../workOrderQueries';

export const useUpdateWorkOrderOtherPriceRationale = () => {
    const dispatch = useDispatch();

    const [resetUpdateData] = useResetStoreData({ requestId: 'uerUpdateWorkOrderOtherPriceRationale' });

    const [, uerUpdateWorkOrderOtherPriceRationaleStatus, , updateWorkOrderOtherPriceRationale] = useRequest({
        requestId: 'uerUpdateWorkOrderOtherPriceRationale',
        query: uerUpdateWorkOrderOtherPriceRationaleGql,
        withEffect: false,
    });

    const updateWorkOrderOtherPriceRationaleHandler = useCallback(
        (rationale: string, workOrderOtherPriceId: number) => {
            dispatch(
                updateWorkOrderOtherPriceRationale({
                    workOrderOtherPriceId,
                    input: {
                        rationale,
                    },
                }),
            );
        },
        [updateWorkOrderOtherPriceRationale, dispatch],
    );

    useEffect(
        () => () => {
            resetUpdateData(undefined);
        },
        [resetUpdateData],
    );

    return useMemo(
        () => ({
            uerUpdateWorkOrderOtherPriceRationaleStatus,
            updateWorkOrderOtherPriceRationaleHandler,
        }),
        [updateWorkOrderOtherPriceRationaleHandler, uerUpdateWorkOrderOtherPriceRationaleStatus],
    );
};
